import React, { useState, useEffect } from 'react';

import { EntityList } from '@vromo/models';
import { Role } from '@vromo/models';

import { css } from 'emotion';

import TeamEditor from './TeamEditor';
import Title from '@vromo/ui/components/Title';
import { useStore } from '@vromo/mobx-react';
import { observer } from 'mobx-react-lite';
import { update } from 'serializr';
import { RootStore } from '../stores/RootStore';

export default observer(function TeamsManager() {
    const rootStore = useStore<RootStore>('rootStore');
    const [roles] = useState(new EntityList(Role));

    const { graph, role } = rootStore.authStore;

    useEffect(() => {
        graph.root
            .graph()
            .roles(role.id)
            .account()
            .roles()
            .get()
            .then(({ items }) => {
                update(roles, { items });
            });
    });

    return (
        <>
            <div
                style={{
                    overflowY: 'auto'
                }}>
                <Title style={{ marginLeft: 16 }}>Teams</Title>
                <div
                    className={css`
                        display: flex;
                        flex-direction: row;

                        @media (max-width: 500px) {
                            flex-direction: column;
                        }
                    `}>
                    <div style={{ flex: 1 }}>
                        <TeamEditor roles={roles} />
                    </div>
                </div>
            </div>
        </>
    );
});
